import { useContext, useState } from "react";
import PopupContext from "../../../context/context-popup";

import SidePopup from "../../../components/side-popup";
import List from "../../../components/list";
import InputsTextArea from "../../../components/inputs/inputs-text-area";
import { ButtonAdd, ButtonCancel, ButtonModify, ButtonRemove, ButtonSave } from "../../../components/buttons";
import meetingsApi from "../../../lib/meetings/meetings-api";
import InputsText from "../../../components/inputs/inputs-text";
import ContentDropdown from "../../../components/content-dropdown";
import LabelContainer from "../../../components/label-container";
import Container from "../../../layouts/containers/container";
import Row from "../../../components/row";
import InputsCheckbox from "../../../components/inputs/inputs-checkbox";

import { toast } from 'react-toastify';
import ErrorContainer from "../../../components/error-container";

export default function PopupsAddGuest({ booking, onCreate = () => {} }) {
    const { closePopup } = useContext(PopupContext);
    const [ errors, setErrors ] = useState({});

    const [ params, setParams ] = useState({

    })

    const save = () => {
       meetingsApi.addAttendeeToBooking(booking?.id, params, (errors) => {
            setErrors(errors);
        }).then(({ data }) => {
            toast.success("Successfully added attendee", {
                position: toast.POSITION.BOTTOM_CENTER
            });

            onCreate();
            closePopup()
        }); 
    }

    const removeAttendee = (id) => {
        meetingsApi.removeAttendeeToBooking(booking?.id, {
            attendee_id: id,
        }, (errors) => {
            setErrors(errors);
        }).then(({ data }) => {
            toast.success("Successfully deleted attendee", {
                position: toast.POSITION.BOTTOM_CENTER
            });

            onCreate();
            closePopup()
        }); 
    }

    const onDetailsChange = (e) => {
        const { name, value } = e.target;
        const details = params?.attendee_details === undefined ? {} : { ...params.attendee_details };

        details[name] = value;

        onChange({ target: { name: 'attendee_details', value: details } })
    }

    const onChange = (e, callback = () => {}) => {
        const { name, value } = e.target;
        const p = { ...params }

        p[name] = value;

        setParams(p);
        callback();
    }
    
    return (
        <SidePopup title='Add Guests' className="add-guest">
            <ErrorContainer errors={errors?.attendee_id} className="add-guest__errors">
                <List gap="40px">
                    { booking?.meeting_attendees?.length !== booking?.no_attendees && 
                        <ContentDropdown title={`New Attendee`} isOpen={true} toggleable={false}>
                            <List gap="20px">
                                <InputsText 
                                    label="First Name"
                                    name="first_name"
                                    onChange={onDetailsChange}
                                    value={params?.attendee_details?.first_name || ''}
                                    errors={errors?.['attendee_details.first_name']}
                                />
                        
                                <InputsText 
                                    label="Last Name"
                                    name="last_name"
                                    onChange={onDetailsChange}
                                    value={params?.attendee_details?.last_name || ''}
                                    errors={errors?.['attendee_details.last_name']}
                                />
                        
                                <InputsText 
                                    label="Business Name"
                                    name="business_name"
                                    onChange={onDetailsChange}
                                    value={params?.attendee_details?.business_name || ''}
                                    errors={errors?.['attendee_details.business_name']}
                                />
                        
                                <InputsText 
                                    label="Email Address"
                                    name={'email_address'}
                                    onChange={onDetailsChange}
                                    value={params?.attendee_details?.email_address || ''}
                                    errors={errors?.['attendee_details.email_address']}
                                />
                    
                                <InputsText 
                                    label="Telephone"
                                    name={'phone_number'}
                                    onChange={onDetailsChange}
                                    value={params?.attendee_details?.phone_number || ''}
                                    errors={errors?.['attendee_details.phone_number']}
                                />
        
                                <InputsCheckbox
                                    checked={params?.lead_attendee}
                                    name="lead_attendee"
                                    onChange={(e) => onChange({ target: { name: 'lead_attendee', value: e.value }})}
                                    text="Is lead attendee"
                                />

                                <ButtonAdd onClick={save}>Add Attendee</ButtonAdd>
                            </List>
                        </ContentDropdown>
                    }

                    { booking?.meeting_attendee?.length === booking?.no_attendees && <Container.Text color="white">You have reached the max amount of attendees</Container.Text>}

                    <List gap="20px">
                        { booking?.meeting_attendees?.map((att, index) => {
                            const attendee = att.meeting_attendee;

                            const renderUser = () => {
                                return (
                                    <List gap="20px">
                                        <LabelContainer label={<Container.Text color="#1976F8">Name</Container.Text>}>
                                            { attendee?.name }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Business Name</Container.Text>}>
                                            { attendee?.business_name }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Email Address</Container.Text>}>
                                            { attendee?.email }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Telephone</Container.Text>}>
                                            { attendee?.user_profile?.telephone }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Lead Attendee</Container.Text>}>
                                            { attendee?.lead_attendee ? 'True' : 'False' }
                                        </LabelContainer>
                                    </List>
                                )
                            }

                            const renderContact = () => {
                                return (
                                    <List gap="20px">
                                        <LabelContainer label={<Container.Text color="#1976F8">First Name</Container.Text>}>
                                            { attendee?.first_name }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Last Name</Container.Text>}>
                                            { attendee?.last_name }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Business Name</Container.Text>}>
                                            { attendee?.business_name }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Email Address</Container.Text>}>
                                            { attendee?.email }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Telephone</Container.Text>}>
                                            { attendee?.telephone }
                                        </LabelContainer>

                                        <LabelContainer label={<Container.Text color="#1976F8">Lead Attendee</Container.Text>}>
                                            { attendee?.lead_attendee ? 'True' : 'False' }
                                        </LabelContainer>
                                    </List>
                                )
                            }
                            
                            return <ContentDropdown title={`Attendee ${index + 1}`} key={index} right={
                                <ButtonRemove mobile onClick={() => removeAttendee(att.id)}/>
                            }>
                                { attendee.hasOwnProperty('name') ? renderUser() : renderContact() }
                            </ContentDropdown>
                        })}
                    </List>
                </List>
            </ErrorContainer>
        </SidePopup>
    )
}